import { atom, selector } from "recoil";
import { getFullFlightListRequest } from "../../../api/controller/CaseFileController";


export const flightSummaryArrivalFlightState = atom({
    key: 'flightSummaryArrivalFlightState',
    default: {
        data: [],
        ovf: false,
    }
})
export const flightSummaryReportDataState = atom({
    key: 'flightSummaryReportDataState',
    default: null
})

export const flightSummaryDataStructureState = selector({
    key: 'flightSummaryDataStructureState',
    get: ({ get }) => (
        [
            {
                label: 'Flight Date',
                type: 'datepicker',
                order: { form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d', default: 'today' } }],
                child: {
                    name: "Flight",
                    subFields: { label: "name", value: "name" }, 
                    fn: getFullFlightListRequest
                }
            },
            { 
                label: 'Flight',
                type: 'select',
                rootValue: true,
                order: { form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'disabled_if:FlightDate,null', creatable: true }],
                list: get(flightSummaryArrivalFlightState)
            },    
        ]
    )
})